<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="title">LULU’S PROVENÇAL TABLE</p>
<p class="title1">RICHARD OLNEY</p>
<p class="imaget"><img alt="Image" src="images/Title.jpg"/></p>
<p class="title2">GRUB STREET · LONDON</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?af5a14bc